﻿/**
 * session Module
 * @module sessionModule
 * @namespace components.sessionModule
 */
'use strict';

angular.module('components.sessionModule', [
    'components.authenticationModule'
])
.factory('sessionManagementFactory', require('./sessionManagementFactory.js'))
.controller('sessionTimeOutWarningModalController', require('./sessionTimeOutWarningModalController.js'))
.controller('sessionManagementController', require('./sessionManagementController.js'));


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/session/index.js
// module id = 26
// module chunks = 0